import type { TNodeType } from '../types'

type NodeWithType =
  { nodeType: TNodeType; gatewayType?: never } | { nodeType?: never; gatewayType: TNodeType }

type NetworkType = 'SN' | 'DN' | 'LN' | 'EX'

export const getNodeNetworkType = (node: NodeWithType | TNodeType): NetworkType => {
  let networkType

  if (typeof node === 'string') {
    networkType = node.match(/(dn|ln|ex)_/)
  } else {
    networkType = (node.nodeType || node.gatewayType).match(/(dn|ln|ex)_/)
  }

  if (networkType) {
    return networkType[1].toUpperCase() as NetworkType
  } else {
    return 'SN'
  }
}

export const isExternalNode = (node: NodeWithType | TNodeType): boolean => {
  if (!node) return false

  if (typeof node === 'string') {
    return node.startsWith('ex_')
  }

  return (node.nodeType || node.gatewayType).startsWith('ex_')
}

export const isSemiosGatewayType = (node: NodeWithType | TNodeType): boolean => {
  if (typeof node === 'string') {
    return node.endsWith('gtwy') && !isExternalNode(node)
  }

  return (node.nodeType || node.gatewayType).endsWith('gtwy') && !isExternalNode(node)
}
